//Paquetes NPM de GYF. 
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Mediator } from 'com-gyf-webcore-mediator';
import { Engine1Proxy, RestApiProxy, ConciergeProxy, SagasProxy } from 'com-gyf-webcore-servicehub';

//Import del reducer de DistribucionLimites.
import NuevaSolicitud from '../../../store/Reducers/NuevaSolicitud';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

//ACTION TYPES
export const GET_SCREEN_DATA = 'GET_SCREEN_DATA';
export const SET_FUNCIONES_DE_USUARIO = 'SET_FUNCIONES_DE_USUARIO';
export const GET_SCREEN_DATA_RESULT_CREAR_CIRCUITO_ESTADO = 'GET_SCREEN_DATA_RESULT_CREAR_CIRCUITO_ESTADO';
export const CAMBIAR_CANTIDAD_ESTADOS = 'CAMBIAR_CANTIDAD_ESTADOS';
export const SELECCIONAR_PRODUCTO = 'SELECCIONAR_PRODUCTO';
export const INICIAR_CREACION_CIRCUITO = 'INICIAR_CREACION_CIRCUITO';
export const ASIGNAR_NOMBRE_ESTADO = 'ASIGNAR_NOMBRE_ESTADO';
export const SIGUIENTE_ESTADO_CREACION_CIRCUITO = 'SIGUIENTE_ESTADO_CREACION_CIRCUITO';
export const ASIGNAR_DOCUMENTACION_A_ESTADO_CIRCUITO = 'ASIGNAR_DOCUMENTACION_A_ESTADO_CIRCUITO';
export const ACTUALIZAR_CANTIDAD_ESTADOS_SALIDA = 'ACTUALIZAR_CANTIDAD_ESTADOS_SALIDA';
export const ASIGNAR_ESTADO_DE_SALIDA = 'ASIGNAR_ESTADO_DE_SALIDA';
export const CANCELAR_EDICION = 'CANCELAR_EDICION';
export const FINALIZAR_GUARDADO = 'FINALIZAR_GUARDADO';
export const RECONSTRUIR_WORKFLOW = 'RECONSTRUIR_WORKFLOW';

let _dispatch;

/**
 * Obtiene el estado inicial de la pantalla.
 * @param {any} state
 * @param {any} currentScope
 */
export function getScreenData(state, currentScope) {
    LogHelper.In(getScreenData.name, state, currentScope);
    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({ type: GET_SCREEN_DATA });

        Mediator.SetCallbackFunction(_loadFuncionesUsuario);
        Mediator.SetEngine1Proxy(Engine1Proxy);

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadFuncionesUsuario(data), null, "GETFUNCTIONS", currentScopeRequest, null, "DELIVERY");
    }
    //LogHelper.Out(getScreenData.name, state, currentScope);
}

/**
 * 
 * @param {any} value
 * @param {any} type
 */
export function cambiarCombo(value, type) {
    //LogHelper.In(cambiarCombo.name, value, type);
    return (dispatch, getState) => {
        _dispatch = dispatch;

        if (type == 'CANTIDADESTADO') {
            dispatch({ type: CAMBIAR_CANTIDAD_ESTADOS, cantidadEstados: value });
        } else if (type == 'PRODUCTO') {
            let parameter = {
                PRODUCTO_TIPO_ID: parseInt(value)
            };

            Engine1Proxy.AddDataSourcesRequests(parameter, 'GET_WORKFLOW_BY_PRODUCTO_TIPO_ID', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');
            Engine1Proxy.Execute(_getWorkflowCallback, null, value, "DELIVERY");
        }
    }
    //LogHelper.Out(cambiarCombo.name, value, type);
}

/**
 * 
 */
export function inicioCreacion() {
    //LogHelper.In(inicioCreacion.name);
    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: INICIAR_CREACION_CIRCUITO });
    }
    //LogHelper.Out(inicioCreacion.name);
}

/**
 * 
 * @param {any} estado
 * @param {any} idEstado
 */
export function asignarNombreEstado(estado, idEstado) {
    //LogHelper.In(asignarNombreEstado.name);
    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: ASIGNAR_NOMBRE_ESTADO, estado: estado, idEstado: idEstado });
    }
    //LogHelper.Out(asignarNombreEstado.name);
}

/**
 * 
 * @param {any} tipo
 */
export function siguenteEstado(tipo) {
    //LogHelper.In(siguenteEstado.name);
    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: SIGUIENTE_ESTADO_CREACION_CIRCUITO, tipo: tipo });
    }
    //LogHelper.Out(siguenteEstado.name);
}

/**
 * 
 * @param {any} idDocumentacion
 * @param {any} estado
 */
export function asignarDocumentacionAEstado(idDocumentacion, estado) {
    //LogHelper.In(asignarDocumentacionAEstado.name);
    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: ASIGNAR_DOCUMENTACION_A_ESTADO_CIRCUITO, idDocumentacion: idDocumentacion, estado: estado });
    }
    //LogHelper.Out(asignarDocumentacionAEstado.name);
}

/**
 * 
 * @param {any} cantidad
 * @param {any} estado
 */
export function actualizarCantidadEstadosSalida(cantidad, estado) {
    //LogHelper.In(asignarDocumentacionAEstado.name);
    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: ACTUALIZAR_CANTIDAD_ESTADOS_SALIDA, cantidad: cantidad, idEstado: estado });
    }
    //LogHelper.Out(asignarDocumentacionAEstado.name);
}

/**
 * 
 * @param {any} estado
 * @param {any} estadoSalida
 * @param {any} estadoSeleccionado
 */
export function asignarEstadoDeSalida(estado, estadoSalida, estadoSeleccionado) {
    //LogHelper.In(asignarEstadoDeSalida.name, estado, estadoSalida);
    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: ASIGNAR_ESTADO_DE_SALIDA, estado: estado, estadoSalida: estadoSalida, estadoSeleccionado: estadoSeleccionado });
    }
    //LogHelper.Out(asignarEstadoDeSalida.name, estado, estadoSalida);
}

/**
 * 
 */
export function cancelarEdicion() {
    //LogHelper.In(cancelarEdicion.name);
    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: CANCELAR_EDICION });
    }
    //LogHelper.Out(cancelarEdicion.name);
}

/**
 * 
 * @param {any} data
 */
export function finalizarCreacion(data) {
    //LogHelper.In(finalizarCreacion.name, data);
    return (dispatch, getState) => {
        let estado = getState();

        let parameters = {
            TIPO_PRODUCTO: estado.CrearCircuitoEstados.productoSeleccionado.Id
        }

        //Borra el workflow creado...
        Engine1Proxy.AddDataSourcesRequests(parameters, 'BORRAR_WORKFLOW_BY_TIPO_PRODUCTO', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');
        Engine1Proxy.Execute(_guardarWorkflow, null, estado, "DELIVERY");
    }
    //LogHelper.Out(finalizarCreacion.name, data);
}

/** ------------------------------     FUNCIONES AUXILIARES    --------------------------------  **/

/**
 * 
 * @param {any} data
 */
function _loadFuncionesUsuario(data) {
    //LogHelper.In(_loadFuncionesUsuario.name, data);

    let userFunctions = {};
    let funcionesUsuario = {};

    if (data.DELIVERY)
        userFunctions = JSON.parse(JSON.stringify(data.DELIVERY)); //Permisos del usuario para la feature a utilizar.    

    for (var i = 0; i < userFunctions.length; i++) {
        funcionesUsuario[userFunctions[i].Codigo_Funcion] = true;
    }

    _dispatch({ type: SET_FUNCIONES_DE_USUARIO, funciones: funcionesUsuario });

    /*Si tiene permisos sobre la consulta de la pantalla, hago el resto de las llamadas*/
    if (funcionesUsuario.Consulta) {
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_DELIVERY_PRODUCTO_TIPO', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_DELIVERY_ESTADO', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'DELIVERY_DOCUMENTO_TIPO', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');

        Engine1Proxy.Execute(_loadFuncionesUsuarioCallBack, undefined, undefined, "DELIVERY");
    }

    //LogHelper.Out(_loadFuncionesUsuario.name, data);
}

/**
 * 
 * @param {any} data
 */
function _loadFuncionesUsuarioCallBack(data) {
    let result = {
        deliveryProductoTipo: JSON.parse(data['GET_DELIVERY_PRODUCTO_TIPO']).Recordset0.Rows,
        deliveryestado: JSON.parse(data['GET_DELIVERY_ESTADO']).Recordset0.Rows,
        deliveryDocumentoTipo: JSON.parse(data['DELIVERY_DOCUMENTO_TIPO']).Recordset0.Rows
    }

    _dispatch({
        type: GET_SCREEN_DATA_RESULT_CREAR_CIRCUITO_ESTADO,
        result: result
    });
}

/**
 * 
 * @param {any} data
 */
function _crearWorkflowCallback(data) {
    _dispatch({ type: FINALIZAR_GUARDADO });
}

/**
 * 
 * @param {any} data
 */
function _getWorkflowCallback(data) {
    let pasosWorkflow = JSON.parse(data['GET_WORKFLOW_BY_PRODUCTO_TIPO_ID']).Recordset0.Rows;
    if (pasosWorkflow.length > 0) {
        _dispatch({ type: RECONSTRUIR_WORKFLOW, productoSeleccionado: data.CALLER_ID, pasosWorkflow: pasosWorkflow });
    } else {
        _dispatch({ type: SELECCIONAR_PRODUCTO, productoSeleccionado: data.CALLER_ID });
    }
}

/**
 * 
 * @param {any} estado
 * @param {any} documentoTipo
 * @param {any} producto
 * @param {any} nroPaso
 */
function getPaso(estado, documentoTipo, producto, nroPaso) {
    return {
        DELIVERY_ESTADO_ID: estado !== undefined ? estado : null,
        SIGUIENTE: null,
        ANTERIOR: null,
        COMIENZA: false,
        FINALIZA: false,
        DOCUMENTO_TIPO_ID: documentoTipo !== undefined ? documentoTipo : null,
        PRODUCTO_ID: producto !== undefined ? producto : null,
        NUMERO_PASO: nroPaso
    }
}

/**
 * 
 * @param {any} data
 */
function _guardarWorkflow(data) {
    let pasoWorkflow = [];
    let estadoActual = data.CALLER_ID;
    let estados = estadoActual.CrearCircuitoEstados.estados;
    let cantidadEstados = estadoActual.CrearCircuitoEstados.cantidadEstados;
    let productoSeleccionadoId = estadoActual.CrearCircuitoEstados.productoSeleccionado.Id;

    for (var i = 0; i < estados.length; i++) {
        let paso = {
            DELIVERY_ESTADO_ID: null,
            SIGUIENTE: null,
            ANTERIOR: null,
            COMIENZA: false,
            FINALIZA: false,
            DOCUMENTO_TIPO_ID: null,
            PRODUCTO_ID: null
        };

        let estadosSalida = [];
        let estadosEntrada = [];

        //Agrega estados salida...
        for (var j = 0; j < estados[i].EstadosSalida.length; j++) {
            estadosSalida.push(estados[i].EstadosSalida[j].estadoId);
        }

        //Agrega estados entrada...
        for (var l = 0; l < estados.length; l++) {
            let estadoEntrada = estados[l].EstadosSalida.find(x => x.estadoId == estados[i].EstadoInfo.Id);
            if (estadoEntrada !== undefined)
                estadosEntrada.push(estados[l].EstadoInfo.Id);
        }

        //Si es comienzo...
        if (estadosEntrada.length == 0 && estados[i].EstadoNumero == 1) {
            for (var k = 0; k < estadosSalida.length; k++) {
                let paso = getPaso(estados[i].EstadoInfo.Id, estados[i].RequiereDocumentacion, productoSeleccionadoId, estados[i].EstadoNumero);
                paso.COMIENZA = true;
                paso.SIGUIENTE = estadosSalida[k];
                pasoWorkflow.push(paso);
            }//Si es final...
        } else if (estados[i].EstadoNumero == cantidadEstados) {
            for (var k = 0; k < estadosEntrada.length; k++) {
                let paso = getPaso(estados[i].EstadoInfo.Id, estados[i].RequiereDocumentacion, productoSeleccionadoId, estados[i].EstadoNumero);
                paso.FINALIZA = true;
                paso.ANTERIOR = estadosEntrada[k];
                pasoWorkflow.push(paso);
            }//Para el resto de los casos...
        } else {
            for (var k = 0; k < estadosSalida.length; k++) {
                for (var m = 0; m < estadosEntrada.length; m++) {
                    let paso = getPaso(estados[i].EstadoInfo.Id, estados[i].RequiereDocumentacion, productoSeleccionadoId, estados[i].EstadoNumero);
                    paso.ANTERIOR = estadosEntrada[m];
                    paso.SIGUIENTE = estadosSalida[k];
                    pasoWorkflow.push(paso);
                }
            }
        }
    }

    let parameters = {
        "pasos": pasoWorkflow
    };

    Engine1Proxy.AddRuleRequests(parameters, 'CrearWorkflow', 'Tarjetas', 'Delivery');
    Engine1Proxy.Execute(_crearWorkflowCallback, null, null, "DELIVERY");
}